import * as yup from 'yup'

const schemaActivility = () =>
  yup.object().shape({
    name: yup.string().required(),
    active: yup.bool(),
  })

export default schemaActivility
